import apiClient from './apiClient';
import { Player, PlayersResponse } from '../types/user';


class UserService {
  private baseUrl = '/api/user';

  // Получить топ игроков
  async getTopPlayers(gameType: string = 'airsoft', limit: number = 10): Promise<Player[]> {
    try {
      const response = await apiClient.get<Player[]>(`${this.baseUrl}/top`, {
        params: { gameType, limit }
      });
      return response;
    } catch (error) {
      console.error('Error fetching top players:', error);
      return [];
    }
  }

  // Получить всех игроков с пагинацией
  async getPlayers(
    gameType: string = 'airsoft',
    page: number = 1,
    pageSize: number = 20,
    search: string = ''
  ): Promise<PlayersResponse> {
    try {
      const response = await apiClient.get<PlayersResponse>(`${this.baseUrl}`, {
        params: { gameType, page, pageSize, search }
      });
      return response;
    } catch (error) {
      console.error('Error fetching players:', error);
      return {
        players: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: page,
        pageSize: pageSize,
        hasMore: false
      };
    }
  }

  // Получить профиль игрока
  async getPlayerProfile(userId: string): Promise<Player> {
    try {
      const response = await apiClient.get<Player>(`${this.baseUrl}/${userId}`);
      return response;
    } catch (error) {
      console.error('Error fetching player profile:', error);
      throw new Error('Player not found');
    }
  }

  // Поиск игроков
  async searchPlayers(searchTerm: string, limit: number = 20, gameType: string = ''): Promise<Player[]> {
    try {
      const response = await apiClient.get<Player[]>(`${this.baseUrl}/search`, {
        params: { searchTerm, limit, gameType }
      });
      return response;
    } catch (error) {
      console.error('Error searching players:', error);
      return [];
    }
  }

  // Обновить профиль пользователя
  async updatePlayerProfile(
    userId: string,
    profileData: {
      name?: string;
      email?: string;
      state?: string;
      primaryBase?: string;
      secondaryBases?: string[];
      gameDisplayPreference?: string;
    }
  ): Promise<Player> {
    try {
      console.log('🔄 Updating player profile...');
      console.log('User ID:', userId);
      console.log('Profile data:', profileData);
      console.log('API URL:', `${this.baseUrl}/${userId}`);
      console.log('Current time:', Date.now());


      
      
      const response = await apiClient.put<Player>(`${this.baseUrl}/${userId}`, profileData);
      
      console.log('✅ Profile updated successfully!');
      console.log('Response:', response);
      return response;
    } catch (error) {
      console.log('❌ Profile update failed:', error);
      throw error;
    }
  }
}

export default new UserService(); 